import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import {
  providesList,
  cacheByIdArg,
  invalidatesList,
  cacheByIdArgProperty,
} from 'utils/query-cache';

import { apiQuery } from '../../query';

import { Attribute, CreateAttributeFormValues } from './types';

const tagType = 'Attributes';

export const attributesApi = createApi({
  tagTypes: [tagType],
  baseQuery: apiQuery,
  reducerPath: 'attributesApi',
  endpoints: (build) => ({
    list: build.query<Attribute[], void>({
      providesTags: providesList(tagType),
      query: (data) => ({
        data,
        method: 'get',
        url: URL.ATTRIBUTES,
      }),
    }),

    get: build.query<Attribute, string>({
      providesTags: cacheByIdArg(tagType),
      query: (id) => ({
        method: 'get',
        url: URL.ATTRIBUTE.replace(':id', String(id)),
      }),
    }),

    delete: build.mutation<void, string>({
      invalidatesTags: invalidatesList(tagType),
      query: (id) => ({
        method: 'delete',
        url: URL.ATTRIBUTE.replace(':id', id),
      }),
    }),

    create: build.mutation<void, CreateAttributeFormValues>({
      invalidatesTags: invalidatesList(tagType),
      query: (data) => ({
        data,
        method: 'post',
        url: URL.ATTRIBUTES,
      }),
    }),

    edit: build.mutation<void, Attribute>({
      invalidatesTags: cacheByIdArgProperty(tagType),
      query: ({ id, ...data }) => ({
        data,
        method: 'patch',
        url: URL.ATTRIBUTE.replace(':id', String(id)),
      }),
    }),
  }),
});

export const {
  useGetQuery,
  useListQuery,
  useEditMutation,
  useCreateMutation,
  useDeleteMutation,
} = attributesApi;

export type { Attribute, CreateAttributeFormValues };
